import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import infiniteScroll from 'vue3-infinite-scroll-good'
import 'animate.css';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

/* 引入createPinia，用于创建pinia */
import { createPinia } from 'pinia'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app= createApp(App)
app.use(router)
app.use(pinia)
app.use(ElementPlus)
app.use(infiniteScroll)
app.mount('#app')
